(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tw-pdp-story"] && !Shopify.designMode) return;
  try {
    function openTaoWardsDetailTarget() {
    const id = window.location.hash.slice(1);
    if (!id.startsWith('tw-product-shipping-')) return;
    const detail = document.getElementById(id);
    if (detail instanceof HTMLDetailsElement) detail.open = true;
  }
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href^="#tw-product-shipping-"]');
    if (!link) return;
    const detail = document.getElementById(link.hash.slice(1));
    if (detail instanceof HTMLDetailsElement) detail.open = true;
  });
  window.addEventListener('hashchange', openTaoWardsDetailTarget);
  openTaoWardsDetailTarget();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tw-product-video"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tw-product-video')) {
    customElements.define('tw-product-video', class extends HTMLElement {
      connectedCallback() {
        if (this.video) return;
        this.stage = this.querySelector('.tw-product-video__stage');
        this.video = this.querySelector('video');
        this.playButton = this.querySelector('.tw-product-video__play');
        if (!this.video) return;
        this.addEventListener('click', (event) => event.stopPropagation());
        this.playButton.addEventListener('click', () => this.play());
        this.video.setAttribute('aria-description', this.dataset.instructions);
        this.onDoubleClick = (event) => {
          event.preventDefault();
          event.stopPropagation();
          if (!this.dialog?.open) this.open();
        };
        this.addEventListener('dblclick', this.onDoubleClick, true);
        this.video.addEventListener('dblclick', this.onDoubleClick, true);
        this.video.addEventListener('keydown', (event) => {
          if (event.key !== 'Enter' || event.repeat) return;
          event.preventDefault();
          event.stopPropagation();
          if (!this.dialog?.open) this.open();
        });
        this.video.addEventListener('pointerdown', (event) => {
          if (event.pointerType === 'touch') this.touchStart = { x: event.clientX, y: event.clientY, time: event.timeStamp };
        });
        this.video.addEventListener('pointercancel', () => { this.touchStart = null; this.lastTap = null; });
        this.video.addEventListener('pointerup', (event) => {
          if (event.pointerType !== 'touch' || !this.touchStart || this.dialog?.open) return;
          const start = this.touchStart;
          this.touchStart = null;
          const rect = this.video.getBoundingClientRect();
          if (event.timeStamp - start.time > 300 || Math.hypot(event.clientX - start.x, event.clientY - start.y) > 20 || event.clientY > rect.bottom - 56) {
            this.lastTap = null;
            return;
          }
          const previous = this.lastTap;
          this.lastTap = { x: event.clientX, y: event.clientY, time: event.timeStamp };
          if (!previous || event.timeStamp - previous.time > 350 || Math.hypot(event.clientX - previous.x, event.clientY - previous.y) > 24) return;
          this.lastTap = null;
          event.preventDefault();
          event.stopPropagation();
          this.open();
        });
        this.video.addEventListener('play', () => {
          this.setAttribute('data-started', '');
          document.querySelectorAll('.product-media video, .tw-video-dialog video').forEach((other) => {
            if (other !== this.video) other.pause();
          });
        });
        this.observer = new IntersectionObserver(([entry]) => {
          if (!entry.isIntersecting && !this.dialog?.open) this.video.pause();
        });
        this.observer.observe(this);
        this.parentDialog = this.closest('dialog');
        this.onParentClose = () => this.video.pause();
        this.parentDialog?.addEventListener('close', this.onParentClose);
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.parentDialog?.removeEventListener('close', this.onParentClose);
        this.video?.pause();
        if (this.dialog?.open) this.dialog.close();
        this.dialog?.remove();
      }
      play() {
        this.setAttribute('data-started', '');
        this.video.play().catch(() => {
          if (!this.dialog?.open) this.removeAttribute('data-started');
        });
      }
      open() {
        if (this.dialog?.open) return;
        const time = this.video.currentTime;
        this.video.pause();
        const dialog = document.createElement('dialog');
        dialog.className = 'tw-video-dialog';
        dialog.setAttribute('aria-label', this.dataset.dialogLabel);
        dialog.style.setProperty('--tw-video-ratio', this.style.getPropertyValue('--tw-video-ratio'));
        const close = document.createElement('button');
        close.type = 'button';
        close.className = 'tw-video-dialog__close';
        close.setAttribute('aria-label', this.dataset.closeLabel);
        close.innerHTML = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="m6 6 12 12M18 6 6 18"/></svg>';
        const stage = document.createElement('div');
        stage.className = 'tw-video-dialog__stage';
        dialog.append(close, stage);
        document.body.append(dialog);
        this.dialog = dialog;
        close.addEventListener('click', () => dialog.close());
        dialog.addEventListener('click', (event) => {
          if (event.target !== dialog) return;
          const rect = dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
        });
        dialog.addEventListener('close', () => {
          const resumeTime = this.video.currentTime;
          this.video.pause();
          this.stage.append(this.video);
          this.video.currentTime = resumeTime;
          this.removeAttribute('data-started');
          dialog.remove();
          this.dialog = null;
          if (this.isConnected) this.video.focus({ preventScroll: true });
        }, { once: true });
        stage.append(this.video);
        this.video.currentTime = time;
        dialog.showModal();
        close.focus({ preventScroll: true });
        this.play();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
